namespace GeniuzPOS.Inventory {
    export namespace IcStockReceiveDtService {
        export const baseUrl = 'Inventory/IcStockReceiveDt';

        export declare function Create(request: Serenity.SaveRequest<IcStockReceiveDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcStockReceiveDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockReceiveDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockReceiveDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/IcStockReceiveDt/Create",
            Update = "Inventory/IcStockReceiveDt/Update",
            Delete = "Inventory/IcStockReceiveDt/Delete",
            Retrieve = "Inventory/IcStockReceiveDt/Retrieve",
            List = "Inventory/IcStockReceiveDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockReceiveDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
